import React, { useEffect, useRef, useState } from 'react';
import { Button, Row, Select, useModelStateContext } from 'saladsoft-primitive';
import { useTranslation } from 'react-i18next';
import { TextField } from '@mui/material';
import { SearchParams } from 'types/CommonTypes';
import { useSearchParams } from 'react-router-dom';

const SellerFilterBox = ({ onSearch }: { onSearch: (searchParams: SearchParams) => void }) => {
  const { t } = useTranslation();
  const keywordRef = useRef<any>(null);

  const size = [
    { key: 20, value: t('20 items') },
    { key: 50, value: t('50 items') },
    { key: 100, value: t('100 items') },
  ];

  const { updateServiceModel, serviceModel, stateModel, setState, setMultipleState, unmountModel } =
    useModelStateContext<SearchParams>();

  const [searchParams] = useSearchParams();
  const [params, setParams] = useState<SearchParams>();
  const [isSearch, setIsSearch] = useState(false);

  const handleSearch = () => {
    if (serviceModel.current) {
      const searchParams: Partial<SearchParams> = { ...serviceModel.current };
      if ((searchParams.category as any) === -1) {
        delete searchParams.category;
      }

      if (searchParams.status === 'all') {
        delete searchParams.status;
      }
      setIsSearch(true);
      onSearch(searchParams as SearchParams);
    }
  };

  const resetFilter = () => {
    setMultipleState({
      startDate: '',
      endDate: '',
      category: '',
      status: '',
      size: 50,
      page: 1,
      searchKey: '',
      searchValue: '',
    });

    if (keywordRef.current) {
      keywordRef.current.querySelector('input').value = '';
    }

    setIsSearch(false);
    onSearch({} as SearchParams);
  };

  useEffect(() => {
    const size = searchParams.get('size');
    const page = searchParams.get('page');
    const searchKey = searchParams.get('searchKey');
    const searchValue = searchParams.get('searchValue');

    if (size || page || searchKey || searchValue) {
      setIsSearch(true);
    }

    if (keywordRef.current) {
      keywordRef.current.querySelector('input').value = searchValue ?? '';
    }

    setParams({
      size: size != null ? parseInt(size) : 50,
      page: page != null ? parseInt(page) : 1,
      searchKey: searchKey != null ? searchKey : '',
      searchValue: searchValue != null ? searchValue.trim() : '',
    });

    setMultipleState({
      searchKey: searchKey != null ? searchKey : '',
      searchValue: searchValue != null ? searchValue.trim() : '',
    });
  }, [searchParams]);

  return (
    <div style={{ paddingTop: 10 }}>
      <Row gap="5px" justifyContent="flex-start">
        <Select
          style={{ minWidth: 100 }}
          defaultKey={params?.size ?? 50}
          useRound={false}
          items={size}
          onChange={(value) => {
            if (serviceModel.current) {
              updateServiceModel('size', value.key);
            }
          }}
          placeHolder={`${t('Select Size')}`}
        />

        <Row marginBottom="0px" width="330px" gap="5px">
          <TextField
            ref={keywordRef}
            onChange={(e: any) => {
              if (serviceModel.current) {
                updateServiceModel('searchValue', e.target.value);
              }
            }}
            placeholder={t('seller.sellerName')}
            style={{ width: '100%' }}
            sx={{
              '& .sc-blHHSb': {
                marginBottom: '0px',
              },
              '& .MuiOutlinedInput-root > input': {
                padding: '10px 10px',
              },
            }}
          />
        </Row>
        <Row justifyContent="flex-end">
          <Button style={{ minHeight: 43, borderRadius: 5, minWidth: 70 }} onClick={handleSearch}>
            {t('Search')}
          </Button>
          <>
            {isSearch && (
              <Button
                type="link"
                style={{ minHeight: 43, borderRadius: 5, minWidth: 90, padding: '0 10px' }}
                onClick={resetFilter}
              >
                {t('Reset')}
              </Button>
            )}
          </>
        </Row>
      </Row>
    </div>
  );
};

export default SellerFilterBox;
